const CollectionController = {
  init: function(props={}) {
    this.attachHandlers();
    this.props = Object.freeze(props);
    this.loadQueryParams();

    this.initInfiniteScroll();
    this.initSort();
  },

  attachHandlers: function() {
    const self = this;
    const $body = $("body");
    const $document = $(document);
    $document.on('click', this.handleCloseSelector);
    $document.on('click', '.js-selected', this.handleClickSelected);
    $document.on('click', '.js-filter-add', this.handleAddFilter.bind(this));
    $document.on('click', '.js-filter-remove', this.handleRemoveFilter.bind(this));
    $document.on('click', '.js-filter-clear-all', this.handleClearAll.bind(this));
    $document.on('click', '.js-filter-clear-category', this.handleClearCategory.bind(this));
    $document.on('click', '.js-sort', this.handleSort.bind(this));
    $document.on('click', '.js-sidebar-open', this.handleSidebarOpen);
    $document.on('click', '.js-sidebar-close', this.handleSidebarClose);
    $document.on('click', '.js-toggle', this.handleToggle);
    $document.on('click', '.js-item-swatch', this.handleSwatchSelect);
    $document.on('mouseenter', '.js-item-swatch', this.handleSwatchMouseEnter);
    $document.on('mouseleave', '.js-item-swatch', this.handleSwatchMouseLeave);

    window.addEventListener('popstate', (event) => {
      var url = self.createUrl();
      self.fetchData(url);
    });
  },

  createUrl: function() {
    var params = this.getParams();
    var query = $.param(params).replace(/%2B/g, '+');
    var url = window.location.pathname;
    if(query) {
      url += "?" + query;
    }
    return url;
  },

  fetchData: function(url, options={}) {
    var self = this;
    $.ajax({
      type: "get",
      url: url,

      beforeSend: function () {
        $("body").trigger("loading_show");
      },

      success: function (data) {
        self.renderData(data, options);
      },

      error: function (xhr, text) {
        //$('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
      },

      complete: function () {
        $("body").trigger("loading_hide");
      }
    });
  },

  getParams: function() {
    let params = {};
    
    if(this.activeTags && this.activeTags.length) {
      params.constraint = this.activeTags.join("+");
    }

    if(this.sortBy) {
      params.sort_by = this.sortBy;
    }

    return params;
  },

  //clear all filters
  handleClearAll: function(e) {
    this.activeTags = [];
    this.navigateAndFetch();
  },

  //clear a single category of filters
  handleClearCategory: function(e) {
    var self = this;
    var $category = $(e.currentTarget).closest(".js-filter-category");
    var $checkedInputs = $category.find("input:checked");
    $checkedInputs.each(function () {
      var $input = $(this);
      var tagName = $input.val();

      if (tagName) {
        var tagIndex = self.activeTags.indexOf(tagName);
        if(tagIndex >= 0) {
          self.activeTags.splice(tagIndex, 1);
        }
      }
    });

    this.navigateAndFetch();
  },

  handleClickSelected: function(e) {
    var $currentSelector = $(e.target).closest(".js-selector");
    $(".js-selector").not($currentSelector).removeClass("open");
    $currentSelector.toggleClass("open");
  },

  handleCloseSelector: function(e) {
    if(!$(e.target).closest('.js-selector').length) {
      $('.js-selector').removeClass("open");
    }
  },

  handleAddFilter: function(e) {
    var tagName = $(e.currentTarget).data("value")

    if(tagName) {
      this.activeTags.push(tagName);
      $("body").trigger("tracking_event", {
        action: "Filter",
        category: "Collection",
        label: tagName
      });
      this.navigateAndFetch();
    }
  },

  handleRemoveFilter: function(e) {
    var tagName = $(e.currentTarget).data("value")

    if(tagName) {
      var tagIndex = this.activeTags.indexOf(tagName);
      if(tagIndex >= 0) {
        this.activeTags.splice(tagIndex, 1);
      }
      $("body").trigger("tracking_event", {
        action: "Filter - Remove",
        category: "Collection",
        label: tagName
      });
      this.navigateAndFetch();
    }
  },

  handleSidebarClose: function(e) {
    $("html").removeClass('sidebar-open');
  },

  handleSidebarOpen: function(e) {
    $("html").addClass('sidebar-open');
    $("body").trigger("tracking_event", {
      action: "Mobile Filter Open",
      category: "Collection",
    });
  },

  handleSort: function(e) {
    this.sortBy = $(e.target).data("value");
    $("body").trigger("tracking_event", {
      action: "Sort",
      category: "Collection",
      label: this.sortBy
    });
    this.navigateAndFetch();
  },

  handleSwatchMouseEnter: function() {
    var $el = $(this);
    var $swatchData = $el.find(".js-item-swatch-value");
    var $swatches = $el.closest(".js-item-swatches");
    var $label = $swatches.find(".js-item-swatch-label");
    var swatchName = $swatchData.data('swatch-name');
    $label.html(swatchName);
  },

  handleSwatchMouseLeave: function() {
    var $el = $(this);
    var $swatches = $el.closest(".js-item-swatches");
    var $label = $swatches.find(".js-item-swatch-label");
    var selected = $label.data("selected") || "";
    $label.html(selected);
  },

  handleSwatchSelect: function() {
    var $el = $(this);
    var $swatchData = $el.find(".js-item-swatch-value");
    var $swatches = $el.closest(".js-item-swatches");
    var $label = $swatches.find(".js-item-swatch-label");
    var swatchName = $swatchData.data('swatch-name');
    $label.html(swatchName);
    $label.data("selected", swatchName);

    var swatchImage = $swatchData.data("img");
    if(swatchImage) {
      var $card = $el.closest(".js-card");
      var $image = $card.find(".js-card-image img");
      $image.attr({
        srcset: swatchImage,
        src: swatchImage
      });
    }

    $(".js-item-swatch").removeClass("active");
    $el.addClass("active");
  },

  handleToggle: function() {
    const $el = $(this);
    $("body").trigger("tracking_event", {
      action: "Filter Toggle",
      category: "Collection",
      label: $el.data("text")
    });
    $el.toggleClass('open');
    $el.next().slideToggle();
  },

  initInfiniteScroll: function() {
    var self = this;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        const $target = $(entries[0].target);
        const pageUrl = $target.attr("href");
        self.fetchData(pageUrl, {
          isAppend: true
        });
        observer.disconnect();
      }
    });
    const element = document.querySelector(".js-infinite-scroll");
    if(element) {
      observer.observe(element);
    }
  },

  initSort: function() {
    this.renderSortSelector();
  },

  loadQueryParams: function() {
    var queryParams = {};

    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');

        if (aKeyValue.length > 1) {
          queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }

    this.sortBy = queryParams.sort_by;
    var activeTags = [];
    if(queryParams.constraint) {
      activeTags = queryParams.constraint.split("+");
    }
    this.activeTags = activeTags;
  },

  navigateAndFetch: function() {
    var url = this.createUrl();
    history.pushState({
      params: this.getParams()
    }, "", url);
    this.fetchData(url);
  },

  renderData: function(newPage, options={}) {
    var selectors = {
      items: ".js-collection-items",
      paging: ".js-collection-paging",
      sidebar: ".js-collection-sidebar"
    };
    var currentItems = $(selectors.items);
    var currentPaging = $(selectors.paging);
    var currentSidebar = $(selectors.sidebar);
    var newItems = $(newPage).find(selectors.items);
    var newPaging = $(newPage).find(selectors.paging);
    var newSidebar = $(newPage).find(selectors.sidebar);

    if(options.isAppend) {
      currentItems.append(newItems.children());
    } else {
      currentItems.replaceWith(newItems);
    }
    
    currentPaging.replaceWith(newPaging);
    currentSidebar.replaceWith(newSidebar);

    this.renderSortSelector();
    this.initInfiniteScroll();

    if(options.onComplete) {
      options.onComplete();
    }
  },

  renderSortSelector: function() {
    const $container = $(".js-sort-selector");

    var options = "";
    
    this.sortOptions.forEach((option) => {
      options += `
        <div 
          class="selector__option js-sort" 
          data-value="${option.value}"
        >
          ${option.text}
        </div>
      `;
    });

    var selectedValue = this.sortBy || this.sortOptions[0].value;
    var selectedOption = this.sortOptions.find(o => o.value === selectedValue);

    var iconDown = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" fill="none" viewBox="0 0 13 10"><path stroke="#70717A" stroke-linecap="round" stroke-linejoin="round" stroke-width=".875" d="M1 2l5.5 7L12 2"/></svg>`;
    $container.empty();
    $container.append(`<div class="selector__selected js-selected"><span class="selector__selected-text">Sort by</span>${iconDown}</div>`);
    $container.append(`<div class="selector__options">${options}</div>`);
  },

  sortOptions: [{
    text: "Featured",
    value: "manual"
  }, {
    text: "Price, low to high",
    value: "price-ascending"
  }, {
    text: "Price, high to low",
    value: "price-descending"
  }, {
    text: "Best selling",
    value: "best-selling"
  }]
};

$(function() {
  window.ettitude = window.ettitude || {};
  Object.create(CollectionController).init(window.ettitude.collectionProps);
});